// extracted by mini-css-extract-plugin
var _1 = "t2xd7rV3Adkb2D5nyJfU";
export { _1 as "panel" }
